import React from 'react';

export enum MessageType {
  EditorContinue = 'editor:continue',
  EditorAutoSave = 'editor:autoSave',
  EditorAutoSaveDone = 'editor:autoSaveDone',
  EditorValidation = 'editor:editorValidation',
  SharePoint = 'sharepoint',
}

type EditorContinue = { type: MessageType.EditorContinue }

type EditorAutoSave = { type: MessageType.EditorAutoSave }

type EditorAutoSaveDone = { type: MessageType.EditorAutoSaveDone }

export type EditorValidationType = {
    type: MessageType.EditorValidation,
    isValid: boolean,
    numFields: number,
    errorMessage?: string,
}

type SharePointType = { type: MessageType.SharePoint }

type Messages = EditorContinue | EditorAutoSave | EditorAutoSaveDone | EditorValidationType
                | SharePointType

export function useWindowMessage<T extends Messages['type']>(
  type: T,
  callback: (m: Extract<Messages, { type: T }>, source: MessageEvent['source']) => void,
) {
  const [, setCounter] = React.useState(0);

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'develop') {
      setCounter((counter) => {
        if (counter > 0) {
          // eslint-disable-next-line no-console
          console.warn('useWindowMessage hook expects to run once when it mounts, then clean up when it unmounts. Maybe you need a useCallback?');
        }

        return counter + 1;
      });
    }

    const onMessage = (event: MessageEvent) => {
      if (event.origin === window.location.origin) {
        if (event.data && event.data.type === type) {
          callback(event.data, event.source);
        }
      }
    };

    window.addEventListener('message', onMessage);

    return () => window.removeEventListener('message', onMessage);
  }, [callback, type]);
  return null;
}


export function postTo(
  targetWindow: Window,
  message: Messages,
  // This just needs to postMessage to hellosign-web code through an iframe and
  // it needs to work in Storybook. I think the simplest solution is to just
  // always post to the same origin.
  origin = window.location.origin,
) {

  targetWindow.postMessage(message, origin);

}
